// extracted by mini-css-extract-plugin
export var chevron = "_jj-2";
export var dropdownItems = "_jj-0";
export var item = "_jj-1";